export default __webpack_public_path__ + "static/bsfi-countdown-8964e3c7829dfba0f4783ee1bd75d8ab.gif";